<template>
  <v-container v-if="!userIsRecepcion()" class="fill-height">
    <NoPermission />
  </v-container>
  <div v-if="userIsRecepcion()">
    <v-form @submit.prevent="submitForm">
      <v-container>
        <v-row>
          <v-col cols="12" md="3" v-if="!isNewRecord">
            <v-text-field
              v-model="cobro.caja_fecha"
              label="Fecha"
              readonly
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="3" v-if="!isNewRecord">
            <v-text-field
              v-model="cobro.turno"
              label="Turno"
              readonly
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="3" v-if="!isNewRecord">
            <v-text-field
              v-model="cobro.usuario_iniciales"
              label="Usuario"
              readonly
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="4">
            <v-select
              v-model="cobro.tipo"
              :items="SELECT_COBROS"
              item-title="text"
              item-value="value"
              label="Tipo"
              required
              @update:model-value="getRegisto"
              :menu-props="{ eager: true }"
            ></v-select>
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field
              v-model.number="cobro.registro"
              label="Registro"
              type="number"
              required
              readonly
            ></v-text-field>
          </v-col> </v-row
        ><v-row>
          <v-col cols="12" md="4">
            <v-text-field
              v-model="cobro.factura"
              label="Nº reserva"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field
              v-model.number="cobro.importe"
              label="Importe"
              id="importe"
              type="number"
              step="0.01"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="12">
            <v-textarea v-model="cobro.detalle" label="Detalle"></v-textarea>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="text-center">
            <v-btn type="submit" color="primary" :loading="loading">
              {{ cobro.id ? 'Actualizar' : 'Crear' }} cobro
            </v-btn>
          </v-col>
          <BaseModal
            v-model="showModal"
            :title="modalConfig.title"
            :message="modalConfig.message"
            :type="modalConfig.type"
            :button-text="modalConfig.buttonText"
          />
        </v-row>
      </v-container>
    </v-form>
  </div>
</template>
<script setup>
import { ref, reactive, onMounted, computed } from 'vue'
import { useCobrosStore } from '@/stores/cobrosStore'
import { useVariablesStore } from '@/stores/variablesStore'
import { getUser } from '@/utils/tokenStorage'
import {
  userIsRecepcion,
  getEnvVariable,
  focusFirstInput
} from '@/utils/helpers'
import { SELECT_COBROS } from '@/utils/constants'
import NoPermission from '@/components/common/NoPermission.vue'
import BaseModal from '../common/BaseModal.vue'

const props = defineProps({
  id: {
    type: Number,
    default: null
  }
})

// Estado del modal
const showModal = ref(false)
const modalConfig = reactive({
  title: '',
  message: '',
  type: 'info',
  buttonText: 'Aceptar'
})

const emit = defineEmits(['saved'])
const nombreRegistro = getEnvVariable(
  'VUE_APP_REGISTRO_COBRO',
  'registro_cobro'
)

const cobrosStore = useCobrosStore()
const variablesStore = useVariablesStore()
const userIsRecepcionValue = userIsRecepcion()
const loading = ref(false)
// const usuarios = ref([])

// Métodos para mostrar modales
const showError = (message) => {
  modalConfig.title = 'Error'
  modalConfig.message = message
  modalConfig.type = 'error'
  modalConfig.buttonText = 'Entendido'
  showModal.value = true
}

const cobro = reactive({
  id: null,
  turno: '',
  registro: null,
  detalle: '',
  factura: null,
  importe: null,
  tipo: '',
  hotel: '',
  deleted: 0,
  usuario_iniciales: '',
  caja_fecha: '',
  caja_id: null
})

const isNewRecord = computed(() => !cobro.id)

onMounted(async () => {
  console.log('PagoForm', props.id)
  const userInfo = getUser()
  cobro.usuario = userInfo.usuario
  cobro.usuario_id = userInfo.usuario_id
  cobro.hotel = userInfo.hotel
  const cobroData = await cobrosStore.getCobro(parseInt(props.id))
  cobro.tipo = SELECT_COBROS[0].value
  getRegisto()
  // emit('update:modelValue', cobro.tipo)
  if (props.id) {
    loading.value = true
    try {
      Object.assign(cobro, cobroData)
      cobro.usuario_iniciales = cobroData.usuario_iniciales || ''
      cobro.caja_fecha = cobroData.caja_fecha || ''
      cobro.caja_id = cobroData.caja_id || null
      cobro.importe = parseFloat(cobro.importe, 2)
      // usuarios.value = await cobrosStore.getUsuarios()
    } catch (error) {
      console.error('Error al cargar el cobro:', error)
    } finally {
      loading.value = false
    }
  }
  // Add focus to first enabled input after form is loaded
  focusFirstInput()
})

const submitForm = async () => {
  // si importe es 0, no se puede crear la tarjeta, mostrar modal de error
  if (cobro.importe == null || parseFloat(cobro.importe) == 0) {
    console.log('cobro.importe', cobro.importe)
    showError('El importe debe ser mayor a 0')
    document.getElementById('importe').focus()
    return
  }
  loading.value = true
  try {
    if (cobro.id) {
      await cobrosStore.updateCobro(cobro)
    } else {
      await cobrosStore.createCobro({ ...cobro })
    }
    emit('saved')
  } catch (error) {
    console.error('Error al guardar el cobro:', error)
  } finally {
    loading.value = false
  }
}

defineExpose({
  cobro,
  loading,
  // usuarios,
  isNewRecord,
  submitForm,
  userIsRecepcion: () => userIsRecepcionValue
})

const getRegisto = async () => {
  console.log('cobro.tipo', cobro.tipo)
  try {
    if (cobro.tipo) {
      const valorRegistro = await variablesStore.getValorVariable(
        `${nombreRegistro}_${cobro.tipo}`,
        0
      )
      if (valorRegistro) {
        cobro.registro = parseInt(valorRegistro) + 1
      }
    }
  } catch (error) {
    console.error('Error buscando registro:', error)
  }
}
</script>
